var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bulletins',{attrs:{"Mode":true,"Type":_vm.AppServiceID}})
}
var staticRenderFns = []

export { render, staticRenderFns }